import { forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { DotProps } from '../types';
import { Basic } from '../basic';
import css from './style.module.css';

export const Layout = forwardRef<HTMLSpanElement, DotProps>(function Component(
  { className, ...props },
  forwardedRef
) {
  return (
    <Basic
      {...props}
      className={clsx(className, css.root)}
      ref={forwardedRef}
    />
  );
});
